module.exports = __webpack_public_path__ + "c80585170178f4a7e20fad9a3897c32b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icn-fox-200.png
// module id = 1538
// module chunks = 0